import { render, staticRenderFns } from "./SocialButtonsSmall.vue?vue&type=template&id=598dc320&scoped=true"
import script from "./SocialButtonsSmall.vue?vue&type=script&lang=js"
export * from "./SocialButtonsSmall.vue?vue&type=script&lang=js"
import style0 from "./SocialButtonsSmall.vue?vue&type=style&index=0&id=598dc320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598dc320",
  null
  
)

export default component.exports